import { SIMPLIFIED_NOTICE } from "../privacy/legalDocs";

export type TemplateVars = {
  empresa?: string | null;
  nombre?: string | null;
  giro?: string | null;
  municipio?: string | null;
  remitente?: string | null;
  agenda?: string | null; // liga de Cal.com (IA y ajustes)
  firma?: string | null; // Bloque C2: cómo se presenta quien llama
  enlace_aviso?: string | null; // Bloque C2: liga al aviso de privacidad
};

const OPT_OUT: Record<string, string> = {
  whatsapp: "Si no desea recibir más mensajes, responda BAJA.",
  email: "Si no desea recibir más correos, responda BAJA.",
};

/**
 * Rellena {{empresa}} {{nombre}} {{giro}} {{municipio}} {{remitente}} {{agenda}}.
 * "Encargado" (contacto genérico del directorio) cuenta como nombre vacío.
 * Sin liga de agenda, se quita la frase que la menciona.
 */
export const fillTemplate = (text: string, vars: TemplateVars) =>
  (vars.agenda ? text : text.replace(/[^.?!\n]*\{\{\s*agenda\s*\}\}\.?/g, ""))
    .replace(/\{\{\s*(\w+)\s*\}\}/g, (_, key: string) => {
      const v = vars[key as keyof TemplateVars];
      return key === "nombre" && v === "Encargado" ? "" : (v ?? "");
    })
    .replace(/(^|[ \t])+([,.:;])/gm, "$2") // "Hola ," → "Hola,"
    .replace(/^[,.:;]\s*/gm, "") // ", soy …" al inicio de línea → "soy …"
    .replace(/[ \t]{2,}/g, " ")
    .replace(/\n{3,}/g, "\n\n")
    .trim()
    .replace(/^\p{Ll}/u, (c) => c.toUpperCase());

/**
 * Regla 6 de RAFTEL.md: todo mensaje saliente lleva opción de baja.
 * En correo va siempre como última línea; si el aviso simplificado está publicable (sin
 * marcadores {{ }}, ver legalDocs) se agrega al final, una sola vez.
 */
export const withOptOut = (
  channel: string,
  text: string,
  notice: string | null = SIMPLIFIED_NOTICE,
) => {
  if (!OPT_OUT[channel]) return text;
  const has =
    channel === "email"
      ? /responda BAJA\.?\s*$/i.test(text)
      : /\bbaja\b/i.test(text);
  const withLine = has ? text : `${text}\n\n${OPT_OUT[channel]}`;
  if (channel !== "email" || !notice || withLine.includes(notice))
    return withLine;
  return `${withLine}\n\n${notice}`;
};
